import {
  Autocomplete,
  Box,
  Chip,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import Sidebar from "../../../components/sidebar/sidebar";
import { Routes } from "react-router-dom";
import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
} from "@mui/material";
import { Formik, Form } from "formik";
import { saveAs } from "file-saver"; // to trigger download in browser

import ExcelJS from "exceljs";
import { fetchCustomerLoanCollectionReportService } from "../../../services/reportService";
import { getAllAgentsService } from "../../../services/agentService";
import { toast } from "react-toastify";
import moment from "moment";
import * as XLSX from "xlsx"; // Import XLSX for Excel export

function LoanCollectionReport() {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loans, setLoans] = useState([]);
  const [excelData, setExcelData] = useState([]);
  const [isExcelData, setIsExcelData] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  //   const [customer, setcustomer] = useState([]); // Assuming you will fetch the customer
  const [loading, setLoading] = useState(false);
  const [excelLoading, setExcelLoading] = useState(false);
  const [error, setError] = useState(null);
  const [totalCollections, setTotalCollections] = useState();
  const [agents, setAgents] = useState([]);

  const initialValues = {
    fromDate: null,
    toDate: null,
    frequency: "",
    status: "pending",
    agent: "",
    search: "",
  };
  const [filters, setFilters] = useState(initialValues);
  const frequencies = ["daily", "weekly", "monthly"];
  const statuses = ["pending", "partial", "paid"];

  const fetchAgents = async () => {
    try {
      const agents = await getAllAgentsService(0, 50);
      setAgents(agents?.agentsWithPhoneContacts);
    } catch (err) {
      toast.error(err.message);
    }
  };

  //   const handleFilter = () => {
  //     fetchPigmy();
  //     // Fetch or filter customer based on fromDate and toDate
  //   };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const fetchLoans = async (values) => {
    try {
      console.log(isExcelData);
      setLoading(true);
      const getLoans = await fetchCustomerLoanCollectionReportService(
        values.fromDate, // Formik values now being used
        values.toDate,
        page,
        rowsPerPage,
        values.frequency,
        values.status,
        values.agent,
        isExcelData,
        values.search
      );
      setLoans(getLoans?.loans);
      setExcelData(getLoans?.excelData); // Adjust this based on API response structure
      setTotalCollections(getLoans?.totalCollections); // Adjust this based on API response structure
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  const handleExport = async () => {
    setExcelLoading(true);

    const getLoans = await fetchCustomerLoanCollectionReportService(
      filters.fromDate,
      filters.toDate,
      page,
      rowsPerPage,
      filters.frequency,
      filters.status,
      filters.agent,
      true
    );

    const excelData = getLoans?.excelData || [];

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Loan Collection Report");
    if (filters.status === "pending") {
      worksheet.columns = [
        { header: "SL.NO", key: "SL.NO", width: 8 },
        { header: "Agent Name", key: "Agent Name", width: 20 },
        { header: "Customer Name", key: "Customer Name", width: 30 },
        { header: "Phone Number", key: "Phone Number", width: 10 },
        { header: "Loan Code", key: "Loan Code", width: 10 },
        { header: "Loan Amount", key: "Loan Amount", width: 15 },
        { header: "Due Date", key: "Due Date", width: 28 },
        { header: "Closure Date", key: "Closure Date", width: 28 },
        { header: "DueBy", key: "DueBy", width: 5 },
        { header: "Collection Amount", key: "Collection Amount", width: 18 },
        { header: "Frequency", key: "Frequency", width: 10 },
        {
          header: "Total Collection Amount",
          key: "Total Collection Amount",
          width: 23,
        },
        {
          header: "Remaining Amount",
          key: "Remaining Amount",
          width: 16,
        },

        { header: "Status", key: "Status", width: 12 },
      ];
    } else {
      worksheet.columns = [
        { header: "SL.NO", key: "SL.NO", width: 8 },
        { header: "Agent Name", key: "Agent Name", width: 20 },
        { header: "Customer Name", key: "Customer Name", width: 30 },
        { header: "Phone Number", key: "Phone Number", width: 10 },
        { header: "Loan Code", key: "Loan Code", width: 10 },
        { header: "Loan Amount", key: "Loan Amount", width: 15 },
        { header: "Due Date", key: "Due Date", width: 28 },
        { header: "Closure Date", key: "Closure Date", width: 28 },
        { header: "DueBy", key: "DueBy", width: 5 },
        { header: "Collection Amount", key: "Collection Amount", width: 18 },
        { header: "Frequency", key: "Frequency", width: 10 },
        {
          header: "Total Collection Amount",
          key: "Total Collection Amount",
          width: 23,
        },
        {
          header: "Remaining Amount",
          key: "Remaining Amount",
          width: 16,
        },
        { header: "Collected Date", key: "Collected Date", width: 16 },
        { header: "Status", key: "Status", width: 12 },
      ];
    }

    const columnColors = [
      "FFFFCC", // SL.NO
      "D9EAD3", // Agent Name
      "D0E0E3", // Customer Name
      "FCE5CD", // Phone Number
      "FFF2CC", // Loan Code
      "F4CCCC", // Loan Amount
      "CFE2F3", // Due Date
      "EAD1DC", // DueBy
      "C9DAF8", // Collection Amount
      "D9D2E9", // Frequency
      "C9DAF8",
      "B6D7A8", // Collected Date
      "F9CB9C", // Status
    ];

    // Add rows with styling
    excelData.forEach((row, index) => {
      const dataRow = worksheet.addRow({
        "SL.NO": index + 1,
        "Agent Name": row?.agent?.userName || "",
        "Customer Name": row?.user?.userName || "",
        "Phone Number": row?.primaryPhone?.contactValue || "",
        "Loan Code": row?.loan?.loanCode || "",
        "Loan Amount": row?.loan?.loanAmount || "",
        "Due Date": Array.isArray(row?.dueDates)
          ? row.dueDates.length > 0
            ? `${moment(row.dueDates[0]).format("DD-MM-YYYY")} - ${moment(
                row.dueDates[row.dueDates.length - 1]
              ).format("DD-MM-YYYY")}`
            : ""
          : row?.dueDate
          ? moment(row?.dueDate).format("DD-MM-YYYY")
          : "",
        "Closure Date": row?.loan?.endDate
          ? moment(row?.loan?.endDate).format("DD-MM-YYYY")
          : "-",
        DueBy: row?.dueBy || "",
        "Collection Amount": row?.collectionAmount || "",
        Frequency: row?.loan?.frequency || "",
        "Total Collection Amount": row?.totalCollectionAmount || "",
        "Remaining Amount": row?.loan?.remainingAmount || "",
        "Collected Date":
          row?.status?.toLowerCase() === "pending"
            ? "-"
            : row?.collectionDate
            ? moment(row.collectionDate).format("DD-MM-YYYY")
            : "-",
        Status: row?.status || "",
      });

      // 🎨 Highlight specific cells
      dataRow.getCell("Agent Name").font = {
        color: { argb: "FF1E88E5" },
        bold: true,
      };
      dataRow.getCell("Customer Name").font = {
        color: { argb: "FFF57C00" },
        bold: true,
      };
      dataRow.getCell("Phone Number").font = {
        color: { argb: "FF00897B" },
        bold: true,
      };
      dataRow.getCell("Loan Amount").font = {
        color: { argb: "FF388E3C" },
        bold: true,
      };
      dataRow.getCell("Collection Amount").font = {
        color: { argb: "FFD32F2F" },
        bold: true,
      };
      dataRow.getCell("Total Collection Amount").font = {
        color: { argb: "FFD32F2F" },
        bold: true,
      };
      dataRow.getCell("Remaining Amount").font = {
        color: { argb: "FF388E3C" },
        bold: true,
      };
    });

    // Style the header row
    worksheet.eachRow((row, rowNumber) => {
      row.eachCell((cell, colNumber) => {
        // First row (header)
        if (rowNumber === 1) {
          cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "5252FF" },
          };
          cell.alignment = { vertical: "middle", horizontal: "center" };
        } else {
          // Column-specific alignment
          const centerAlignedCols = [1, 5, 6, 7, 9, 11, 10, 12, 13]; // column numbers (1-based)
          const leftAlignedCols = [2, 3, 4, 8];

          if (centerAlignedCols.includes(colNumber)) {
            cell.alignment = { vertical: "middle", horizontal: "center" };
          } else if (leftAlignedCols.includes(colNumber)) {
            cell.alignment = { vertical: "middle", horizontal: "left" };
          }
        }
      });
    });

    // Export
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, "LoanCollectionReport.xlsx");

    setExcelLoading(false);
  };

  useEffect(() => {
    fetchAgents();
  }, [page, rowsPerPage]);

  useEffect(() => {
    fetchLoans(filters); // fetch loans based on initial filter values
  }, [page, rowsPerPage]); // re-fetch loans on page or rowsPerPage change

  return (
    <>
      <div>
        <Box sx={{ display: "flex" }}>
          <Sidebar />
          <Box component="main" sx={{ flexGrow: 1, pt: 3, pr: 2 }}>
            <Box height={65} />
            <Box>
              <Typography variant="h4">Loan Collection Report</Typography>
            </Box>
            <Paper
              style={{
                color: "#000",
                padding: "20px",
                marginTop: 20,
                borderRadius: "10px",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                // backgroundColor: "#f7f7ff",
              }}
            >
              <Formik
                initialValues={initialValues}
                onSubmit={(values) => {
                  setFilters(values);
                  fetchLoans(values); // Pass Formik values when filtering
                }}
              >
                {({ values, handleChange, setFieldValue }) => (
                  <Form>
                    <Box sx={{ p: 2 }}>
                      <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} sm={2}>
                          <Typography>From Date</Typography>
                          <TextField
                            type="date"
                            name="fromDate"
                            size="small"
                            value={values.fromDate}
                            onChange={handleChange}
                            InputLabelProps={{
                              shrink: true, // This ensures that the label doesn't overlap with the value
                            }}
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                          <Typography>To Date</Typography>
                          <TextField
                            type="date"
                            name="toDate"
                            size="small"
                            value={values.toDate}
                            onChange={handleChange}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            fullWidth
                          />
                        </Grid>

                        <Grid item xs={12} sm={2}>
                          <FormControl fullWidth>
                            <Typography>Frequency</Typography>
                            <Select
                              name="frequency"
                              value={values.frequency}
                              onChange={handleChange}
                              size="small"
                            >
                              {frequencies.map((freq) => (
                                <MenuItem key={freq} value={freq}>
                                  {freq}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={2}>
                          <FormControl fullWidth>
                            <Typography>Status</Typography>
                            <Select
                              size="small"
                              name="status"
                              value={values.status}
                              onChange={handleChange}
                            >
                              {statuses.map((status) => (
                                <MenuItem key={status} value={status}>
                                  {status}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={2}>
                          <FormControl fullWidth>
                            <Typography>Agent</Typography>
                            <Select
                              size="small"
                              name="agent"
                              value={values.agent}
                              onChange={handleChange}
                            >
                              {agents.map((agent) => (
                                <MenuItem key={agent._id} value={agent._id}>
                                  {agent.userName}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={2}>
                          <TextField
                            size="small"
                            label="Search Customer Name"
                            fullWidth
                            onChange={(event) => {
                              setFieldValue("search", event.target.value);
                            }}
                          />
                        </Grid>

                        <Grid item xs={12} sm={12} textAlign="center">
                          <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            startIcon={<i className="fas fa-filter"></i>}
                          >
                            {loading ? (
                              <CircularProgress
                                size={24}
                                style={{ color: "#fff" }}
                              />
                            ) : (
                              "Generate"
                            )}
                          </Button>
                          <Button
                            variant="contained"
                            color="success"
                            onClick={handleExport}
                            sx={{
                              mx: 2,
                              backgroundColor: "green",
                              color: "#fff",
                              "&:hover": { backgroundColor: "#006400" },
                            }}
                          >
                            {excelLoading ? (
                              <CircularProgress
                                size={24}
                                style={{ color: "#fff" }}
                              />
                            ) : (
                              "Download Excel"
                            )}
                          </Button>
                        </Grid>
                      </Grid>
                    </Box>
                  </Form>
                )}
              </Formik>
            </Paper>
            <Box sx={{ mt: 2 }}>
              {" "}
              <TableContainer>
                <Table
                  sx={{
                    minWidth: 650,
                    borderCollapse: "separate",
                    borderSpacing: "0 8px",
                  }}
                >
                  <TableHead>
                    <TableRow sx={{ backgroundColor: "#f3f4f6" }}>
                      {[
                        "SL.NO",
                        "Agent Name",
                        "Customer Name",
                        "Phone Number",
                        "Loan Code",
                        "Loan Amount",
                        "Frequency",
                        "Due Date",
                        "Due By",
                        "Collection Amount",
                        "Paid Amount",
                        "Collected Date",
                        "Status",
                      ].map((header) => (
                        <TableCell
                          key={header}
                          sx={{
                            color: "#5252ff",
                            padding: "6px",
                            fontWeight: "bold",
                            borderBottom: "1px solid #e0e0e0",
                            textAlign: "center",
                          }}
                        >
                          {header}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {loans?.length > 0 ? (
                      loans.map((row, index) => {
                        const isOverdue =
                          new Date(row?.dueDate) < new Date() &&
                          row?.status === "pending";

                        return (
                          <TableRow
                            key={row._id}
                            sx={{
                              backgroundColor: isOverdue
                                ? "#8B0000"
                                : index % 2 === 0
                                ? "#fafafa"
                                : "#ffffff",
                              color: isOverdue ? "#ffffff" : "inherit",
                              borderRadius: "8px",
                              boxShadow: 1,
                            }}
                          >
                            <TableCell
                              sx={{
                                padding: "6px",
                                textAlign: "center",
                                color: isOverdue ? "#ffffff" : "inherit",
                              }}
                            >
                              {index + 1}
                            </TableCell>
                            <TableCell
                              sx={{
                                padding: "6px",
                                textAlign: "center",
                                color: isOverdue ? "#ffffff" : "inherit",
                              }}
                            >
                              {row?.agent?.userName}
                            </TableCell>
                            <TableCell
                              sx={{
                                padding: "6px",
                                textAlign: "center",
                                color: isOverdue ? "#ffffff" : "inherit",
                              }}
                            >
                              {row?.user?.userName}
                            </TableCell>
                            <TableCell
                              sx={{
                                padding: "6px",
                                textAlign: "center",
                                color: isOverdue ? "#ffffff" : "inherit",
                              }}
                            >
                              {row?.primaryPhone?.contactValue}
                            </TableCell>
                            <TableCell
                              sx={{
                                padding: "6px",
                                textAlign: "center",
                                color: isOverdue ? "#ffffff" : "inherit",
                              }}
                            >
                              {row?.loan?.loanCode}
                            </TableCell>
                            <TableCell
                              sx={{
                                padding: "6px",
                                textAlign: "center",
                                color: isOverdue ? "#ffffff" : "inherit",
                              }}
                            >
                              {row?.loan?.loanAmount}
                            </TableCell>
                            <TableCell
                              sx={{
                                padding: "6px",
                                textAlign: "center",
                                color: isOverdue ? "#ffffff" : "inherit",
                              }}
                            >
                              {row?.loan?.frequency}
                            </TableCell>
                            <TableCell
                              sx={{
                                padding: "6px",
                                textAlign: "center",
                                color: isOverdue ? "#ffffff" : "inherit",
                              }}
                            >
                              {moment(row?.dueDate).format("DD-MM-YYYY")}
                            </TableCell>
                            <TableCell
                              sx={{
                                padding: "6px",
                                textAlign: "center",
                                color: isOverdue
                                  ? "#ffffff"
                                  : row?.dueBy > 0
                                  ? "red"
                                  : "green",
                              }}
                            >
                              {row?.dueBy || 0}
                            </TableCell>
                            <TableCell
                              sx={{
                                padding: "6px",
                                textAlign: "center",
                                color: isOverdue ? "#ffffff" : "inherit",
                              }}
                            >
                              {row?.collectionAmount}
                            </TableCell>
                            <TableCell
                              sx={{
                                padding: "6px",
                                textAlign: "center",
                                color: isOverdue ? "#ffffff" : "inherit",
                              }}
                            >
                              {row?.paidAmount}
                            </TableCell>
                            <TableCell
                              sx={{
                                padding: "6px",
                                textAlign: "center",
                                color: isOverdue ? "#ffffff" : "inherit",
                              }}
                            >
                              {row?.collectionDate
                                ? moment(row.collectionDate).format(
                                    "DD-MM-YYYY"
                                  )
                                : "-"}
                            </TableCell>
                            <TableCell
                              sx={{
                                padding: "6px",
                                textAlign: "center",
                                color:
                                  row?.status === "pending"
                                    ? "#ffffff"
                                    : "inherit",
                              }}
                            >
                              {row?.status === "paid" ||
                              row?.status === "partial" ? (
                                <Chip
                                  label={row?.status}
                                  sx={{
                                    backgroundColor:
                                      row?.status === "paid"
                                        ? "#4CAF50"
                                        : "#CC7000", // Green for paid, dark orange for partial
                                    color: "#ffffff",
                                    fontWeight: "bold",
                                    padding: "0 8px",
                                    height: "24px",
                                    fontSize: "12px",
                                  }}
                                  size="small"
                                />
                              ) : (
                                row?.status
                              )}
                            </TableCell>
                          </TableRow>
                        );
                      })
                    ) : (
                      <TableRow>
                        <TableCell
                          colSpan={12}
                          sx={{ textAlign: "center", padding: "16px" }}
                        >
                          No loans available in table
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                component="div"
                count={totalCollections}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelRowsPerPage="Show"
                sx={{
                  "& .MuiTablePagination-actions": { margin: "0 12px" },
                  mt: 2,
                }}
              />
            </Box>
          </Box>
        </Box>
        {/* Outlet is used for rendering nested routes if further nesting is needed */}
      </div>
    </>
  );
}

export default LoanCollectionReport;
